import {
 Box,
 Button,
 Dialog,
 DialogActions,
 DialogContent,
 DialogTitle,
 useMediaQuery,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import themeOptions from '../../../utils/theme';
import CloseButton from '../CloseButton';
// import XTabs from '../XTabs';
// import AuthenticationTab from './AuthenticationTab';
import UserTab from './UserTab';
import { useUserProfileForm } from './hooks/useUserProfileForm';
import { UserProfileModalProps } from './types';

const UserProfileModal: React.FC<UserProfileModalProps> = ({
 open,
 onClose,
}) => {
 const { t } = useTranslation();
 const isLargerThanMd = useMediaQuery(themeOptions().breakpoints.up('md'));

 const profileForm = useUserProfileForm(open, onClose);
 const { handleCancel, handleSaveClick, loading } = profileForm;

 // const { activeTab, setActiveTab } = profileForm;
 //
 // const userTabContent = <UserTab {...profileForm} />;
 //
 // const authenticationTabContent = <AuthenticationTab {...profileForm} />;
 //
 // const tabs = [
 //  { id: 'user', label: t('user.tabs.user'), content: userTabContent },
 //  {
 //   id: 'authentication',
 //   label: t('user.tabs.authentication'),
 //   content: authenticationTabContent,
 //  },
 // ];

 return (
  <Dialog
   open={open}
   onClose={onClose}
   fullWidth
   fullScreen={!isLargerThanMd}
   sx={{
    '& .MuiDialog-container': {
     '& .MuiPaper-root': { width: '100%', maxWidth: '400px' },
    },
   }}
  >
   <DialogTitle sx={{ fontSize: 18 }}>{t('user.title')}</DialogTitle>

   <CloseButton closeDialog={onClose} />

   <DialogContent sx={{ py: 0, px: 3 }}>
    <UserTab {...profileForm} />

    {/* <XTabs
     tabs={tabs}
     defaultTab={0}
     variant="fullWidth"
     ariaLabel="user profile tabs"
     sx={{ px: 3 }}
     tabSx={{
      '& .Mui-selected': {
       color: (th) => th.palette.kemek.blue,
      },
      '& .MuiTabs-indicator': {
       backgroundColor: (th) => th.palette.kemek.blue,
      },
     }}
     panelSx={{ p: 0 }}
     onChange={(newValue) => setActiveTab(newValue)}
    /> */}
   </DialogContent>

   <DialogActions sx={{ padding: '16px 24px', justifyContent: 'flex-end' }}>
    <Box sx={{ display: 'flex', gap: 1 }}>
     <Button
      type="button"
      onClick={handleCancel}
      size="large"
      color="secondary"
      variant="text"
     >
      {t('global.cancel')}
     </Button>
     <Button
      variant="contained"
      type="submit"
      form="user-profile-form"
      size="large"
      onClick={handleSaveClick}
      disabled={
       loading?.usersUpdateSelf === true || loading?.usersGetSelf === true
      }
     >
      {t('user.buttons.save')}
     </Button>
    </Box>
   </DialogActions>
  </Dialog>
 );
};

export default UserProfileModal;
